import { JsClickError } from '../../errors/jsClickError';
import { Url } from './url';

$(() => {
    $('body').on('click', '.js-click, .js-click-no-block', bindJsClick);
});

export function bindJsClick():boolean|void {
    const $this = $(this);
    const params = $.extend({}, $this.data());
    const linkIsDefined = typeof params.link !== 'undefined';
    const handlerIsDefined = typeof params.handler !== 'undefined';
    if (linkIsDefined) {
        window.location.href = Url.getNoLangUrl($this.data('link'));
    } else {
        if (handlerIsDefined) {
            const handler = params.handler;
            delete params.handler;

            try {
                // @ts-ignore
                window.app[handler](params);
            } catch (error) {
                const customError = new JsClickError(`Call ${handler} handler error: ${error.message}`);
                customError.stack = error.stack;
                console.error(customError, handler, params);
                window.Sentry.captureException(customError);
            }
        }
    }

    if ($this.hasClass('js-click-no-block')) {
        return;
    }

    return false;
}
